module.exports = __webpack_public_path__ + "img/icon_map_2_yj_hg.6d46eba5.png";